module.exports = __webpack_public_path__ + "static/media/02-quote-02-aromaria@2x.b86a7114.jpg";